import React from 'react';

import listenerForBrowser from '@app/components/Pages/listenerForBrowser';

export const useMediaQuery = (width: number = 768): boolean => {
	const [matches, setMatches] = React.useState<boolean>(false);

	React.useEffect(() => {
		const mql = window?.matchMedia(`screen and (max-width: ${width}px)`);

		const listenerFunc = () => {
			setMatches(mql.matches);
		};

		listenerFunc();
		listenerForBrowser(mql, listenerFunc);

		return () => {
			try {
				mql.removeEventListener('change', listenerFunc);
			} catch (err) {
				console.error(err);
			}
		};
	}, [width]);

	return matches;
};
